module.exports = __webpack_public_path__ + "img/angelic_recruit.3aa9c76b.png";